module.exports = __webpack_public_path__ + "img/sulam_yes.d5e2668a.png";